// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32ncc","index":"styles_index__dYHCt"};